var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-form",
    [
      _c("gg-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required",
            expression: "'required'"
          }
        ],
        staticClass: "compact-password",
        attrs: {
          outlined: "",
          label: "Current Password",
          type: _vm.showPass ? "text" : "password",
          "error-messages": _vm.errors.collect("Current Password"),
          name: "Current Password"
        },
        scopedSlots: _vm._u([
          {
            key: "append",
            fn: function fn() {
              return [
                _c(
                  "v-btn",
                  {
                    staticClass: "mt-0 mr-1",
                    attrs: {
                      icon: "",
                      ripple: false
                    },
                    on: {
                      click: function click($event) {
                        _vm.showPass = !_vm.showPass
                      }
                    }
                  },
                  [
                    _c(
                      "v-icon",
                      {
                        attrs: {
                          color: "#C2C2C2"
                        }
                      },
                      [_vm._v(_vm._s(_vm.showPass ? "mdi-eye-off" : "mdi-eye"))]
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.model.current_password,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "current_password", $$v)
          },
          expression: "model.current_password"
        }
      }),
      _c("compact-password", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required|no_quotes",
            expression: "'required|no_quotes'"
          }
        ],
        ref: "newPwd",
        attrs: {
          outlined: "",
          label: "New Password",
          "data-vv-name": "password",
          "data-vv-as": "New Password",
          "error-messages": _vm.errors.collect("password"),
          "with-generator": ""
        },
        on: {
          "input-type": _vm.updateShowNewPassword
        },
        model: {
          value: _vm.model.new_password,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "new_password", $$v)
          },
          expression: "model.new_password"
        }
      }),
      _c("gg-text-field", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required|confirmed:newPwd|no_quotes",
            expression: "'required|confirmed:newPwd|no_quotes'"
          }
        ],
        staticClass: "compact-password",
        attrs: {
          outlined: "",
          label: "New Password Confirmation",
          type: _vm.showNewPass ? "text" : "password",
          "error-messages": _vm.errors.collect("New Password Confirmation"),
          name: "New Password Confirmation"
        },
        model: {
          value: _vm.model.new_password_confirm,
          callback: function callback($$v) {
            _vm.$set(_vm.model, "new_password_confirm", $$v)
          },
          expression: "model.new_password_confirm"
        }
      }),
      _c(
        "gg-btn",
        {
          staticClass: "my-4 ml-0 mt-1",
          attrs: {
            color: "primary",
            loading: _vm.loading
          },
          on: {
            click: _vm.changePassword
          }
        },
        [
          _vm._v(" Change Password "),
          _c(
            "span",
            {
              staticClass: "visually-hidden text-lowercase"
            },
            [_vm._v("button")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }